module.exports = __webpack_public_path__ + "static/media/apple.f6228906.png";